export default __webpack_public_path__ + "static/media/gully_01.f45d7820.png";